"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spv = void 0;
const bitcoin_1 = require("../../lib/bitcoin");
class Spv {
    constructor(tbtcContracts, bitcoinClient) {
        this.tbtcContracts = tbtcContracts;
        this.bitcoinClient = bitcoinClient;
    }
    /**
     * Prepares the proof of a deposit sweep transaction and submits it to the
     * Bridge on-chain contract.
     * @param transactionHash - Hash of the transaction being proven.
     * @param mainUtxo - Recent main UTXO of the wallet as currently known on-chain.
     * @param vault - (Optional) The vault pointed by swept deposits.
     * @returns Empty promise.
     */
    async submitDepositSweepProof(transactionHash, mainUtxo, vault) {
        const confirmations = await this.tbtcContracts.bridge.txProofDifficultyFactor();
        const proof = await (0, bitcoin_1.assembleBitcoinSpvProof)(transactionHash, confirmations, this.bitcoinClient);
        const rawTransaction = await this.bitcoinClient.getRawTransaction(transactionHash);
        const rawTransactionVectors = (0, bitcoin_1.extractBitcoinRawTxVectors)(rawTransaction);
        await this.tbtcContracts.bridge.submitDepositSweepProof(rawTransactionVectors, proof, mainUtxo, vault);
    }
    /**
     * Prepares the proof of a redemption transaction and submits it to the
     * Bridge on-chain contract.
     * @param transactionHash - Hash of the transaction being proven.
     * @param mainUtxo - Recent main UTXO of the wallet as currently known on-chain.
     * @param walletPublicKey - Bitcoin public key of the wallet. Must be in the
     *        compressed form (33 bytes long with 02 or 03 prefix).
     * @returns Empty promise.
     */
    async submitRedemptionProof(transactionHash, mainUtxo, walletPublicKey) {
        const confirmations = await this.tbtcContracts.bridge.txProofDifficultyFactor();
        const proof = await (0, bitcoin_1.assembleBitcoinSpvProof)(transactionHash, confirmations, this.bitcoinClient);
        const rawTransaction = await this.bitcoinClient.getRawTransaction(transactionHash);
        const rawTransactionVectors = (0, bitcoin_1.extractBitcoinRawTxVectors)(rawTransaction);
        await this.tbtcContracts.bridge.submitRedemptionProof(rawTransactionVectors, proof, mainUtxo, walletPublicKey);
    }
}
exports.Spv = Spv;
//# sourceMappingURL=spv.js.map